<script setup>
const emit = defineEmits(['handleButtonClick'])

const props = defineProps({
  text: { type: String, default: '' },
  buttonText: { type: String, default: '' },
  buttonIcon: { type: String, default: '' },
})
</script>

<template>
  <section>
    <div class="flex items-center justify-between py-4 px-6 bg-yellow-100">
      <span class="text-xs text-yellow-600">{{ text }}</span>
      <div class="flex items-center gap-x-2 text-sm text-tint-1 font-semibold">
        <button @click="emit('handleButtonClick')">
          {{ buttonText }}
        </button>
        <Icon :icon="buttonIcon" />
      </div>
    </div>
  </section>
</template>